// extracted by mini-css-extract-plugin
export default {"paymentSection":"W4-z","disabled":"X4-z"};